"use client";

import React from "react";
import ModalTextOnlyExample from "@/examples/modals/ModalTextOnlyExample";

export default function ModalTextOnlyPage() {
  return (
    <div className="container mx-auto p-6">
      <ModalTextOnlyExample />
    </div>
  );
}
